module.exports = __webpack_public_path__ + "img/M1_trasera-maquetacion.b60008d5.jpg";